module.exports = __webpack_public_path__ + "static/4na_podu_sq-ad434325f66a359034dfe45a50b107d8.jpg";